import { render, staticRenderFns } from "./tempGajiLantikanPertama.vue?vue&type=template&id=7f6cae1b&"
import script from "./tempGajiLantikanPertama.vue?vue&type=script&lang=js&"
export * from "./tempGajiLantikanPertama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports